import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 12;

const PASSWORD_COMPLEXITY_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/;

export const passwordPolicyValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value as string;

  if (!value) {
    return null;
  }

  if (value.length < PASSWORD_MIN_LENGTH) {
    return { passwordMinLength: { requiredLength: PASSWORD_MIN_LENGTH } };
  }

  if (!PASSWORD_COMPLEXITY_PATTERN.test(value)) {
    return { passwordComplexity: true };
  }

  return null;
};

export const passwordsMatchValidator =
  (passwordKey: string, confirmationKey: string): ValidatorFn =>
  (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordKey)?.value as string;
    const confirmation = group.get(confirmationKey)?.value as string;

    return password && confirmation && password !== confirmation
      ? { passwordsMismatch: true }
      : null;
  };
